import { cn } from 'cn';
import {
  type ClassNamesConfig,
  type GroupBase,
  type StylesConfig,
} from 'react-select';

export function getSelectStyles<
  TOption,
  TIsMulti extends boolean = boolean,
  TGroup extends GroupBase<TOption> = GroupBase<TOption>,
>(
  overrides?: StylesConfig<TOption, TIsMulti, TGroup>,
): StylesConfig<TOption, TIsMulti, TGroup> {
  return {
    control: (provided) => ({
      ...provided,
      minHeight: '2.5rem',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      alignItems: 'center',
    }),
    menu: (provided) => ({
      ...provided,
      margin: 0,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 1500,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'hsl(213 1 60)',
      fontStyle: 'italic',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      paddingRight: 0,
      rowGap: '0.25rem',
    }),
    ...overrides,
  };
}

export function getSelectClassNames<
  TOption,
  TIsMulti extends boolean = boolean,
  TGroup extends GroupBase<TOption> = GroupBase<TOption>,
>({
  classNames,
  hasErrors,
}: {
  classNames?: ClassNamesConfig<TOption, TIsMulti, TGroup>;
  hasErrors: boolean;
}): ClassNamesConfig<TOption, TIsMulti, TGroup> {
  return {
    ...classNames,
    control: (props) =>
      cn(
        hasErrors && 'border-tiga-semantic-error',
        classNames?.control?.(props),
      ),
    option: (props) =>
      cn(
        props.isDisabled && 'cursor-not-allowed text-tiga-text-lighter',
        classNames?.option?.(props),
      ),
  };
}
